export const BadgeContainer = ({ children }) => {
  return (
    <div css={{ display: "flex", gap: 8, flexWrap: "wrap" }}>{children}</div>
  );
};
